import React, { useEffect, useState } from 'react'
import * as R from 'ramda'

import utils from './utils'
import Input from '../form/Input'
import TextArea from '../form/TextArea'
import Tooltip from '../../UniformComponents/Tooltip'

const QuestionSection = ({
    question, targetLocale, isDisabled, defaultLocale, mode, tooltip, hideLock,
}) => {
    const [sections, setSections] = useState([])
    const { metadata: { initialLocale } } = question

    useEffect(() => {
        setSections(utils.getQuestionSections(question))
    }, [])

    const renderLock = () => (
        hideLock
            ? null
            : (
                <div className="icon-tooltip">
                    {!R.isNil(tooltip) && (
                        <Tooltip
                            text={tooltip}
                            direction="up"
                            style={{ width: 350 }}
                        />
                    )}
                    <i className="fa-regular fa-lock" />
                </div>
            )
    )

    const renderContent = (section) => {
        const { label, content, element, hideEmpty } = section
        const hasContent = utils.hasContent(question, content)

        if ((mode === 'survey' || hideEmpty) && !hasContent) return null

        return (
            <>
                {mode !== 'survey' && (
                    <tr className="bg_gray">
                        <td colSpan={2}>{label}</td>
                    </tr>
                )}
                <tr>
                    {mode === 'survey' && (
                        <>
                            <td className={`oid oid${question.metadata.oid}`} />
                            <td style={{ padding: '4px 16px' }}>
                                <b>{label}</b>
                            </td>
                        </>
                    )}
                    <td>{question.content.getTitleByLocale(content, defaultLocale, initialLocale)}</td>
                    <td>
                        {isDisabled && (
                            <div className="disabled">
                                {utils.getContentText(question, content, targetLocale)}
                                {renderLock()}
                            </div>
                        )}
                        {!isDisabled && (
                            <>
                                {element === 'TextArea'
                                    ? (
                                        <TextArea
                                            key={`aboveText_${targetLocale}`}
                                            defaultValue={utils.getContentText(question, content, targetLocale)}
                                            onBlur={({ value }) => question.setContentText(value, content, targetLocale)}
                                        />
                                    ) : (
                                        <Input
                                            key={`aboveText_${targetLocale}`}
                                            defaultValue={utils.getContentText(question, content, targetLocale)}
                                            onBlur={({ value }) => question.setContentText(value, content, targetLocale)}
                                        />
                                    )}
                            </>
                        )}
                    </td>
                </tr>
            </>
        )
    }

    const renderSubQuestions = (section) => {
        const { label } = section

        const subQuestions = question.optionSet

        return (
            <>
                {mode !== 'survey' && (
                    <tr className="bg_gray">
                        <td colSpan={2}>{label}</td>
                    </tr>
                )}
                {subQuestions.map(({ question }) => (
                    <tr key={question.id}>
                        {mode === 'survey' && index === 0 && (
                            <>
                                <td className={`oid oid${question.metadata.oid}`} rowSpan={subQuestions.length} />
                                <td rowSpan={subQuestions.length} style={{ padding: '4px 16px' }}>
                                    <b>{label}</b>
                                </td>
                            </>
                        )}
                        <td>{question.content.getTitleByLocale('shortTitle', defaultLocale, initialLocale)}</td>
                        <td>
                            {isDisabled && (
                                <div className="disabled">
                                    {utils.getContentText(question, 'shortTitle', targetLocale)}
                                    {renderLock()}
                                </div>
                            )}
                            {!isDisabled && (
                                <Input
                                    key={`${question.id}_${targetLocale}`}
                                    defaultValue={utils.getContentText(question, 'shortTitle', targetLocale)}
                                    onBlur={({ value }) => question.setContentText(value, 'shortTitle', targetLocale)}
                                />
                            )}
                        </td>
                    </tr>
                ))}
            </>
        )
    }

    const renderOptions = (section) => {
        const { label, set } = section

        const options = R.pathOr([], [set, 'options'], question)

        return (
            <>
                {mode !== 'survey' && (
                    <tr className="bg_gray">
                        <td colSpan={2}>{label}</td>
                    </tr>
                )}
                {options.map((option, index) => (
                    <tr key={option.id}>
                        {mode === 'survey' && index === 0 && (
                            <>
                                <td className={`oid oid${question.metadata.oid}`} rowSpan={options.length} />
                                <td rowSpan={options.length} style={{ padding: '4px 16px' }}>
                                    <b>{label}</b>
                                </td>
                            </>
                        )}
                        <td>{option.getTitle(defaultLocale, initialLocale)}</td>
                        <td>
                            {isDisabled && (
                                <div className="disabled">
                                    {utils.getOptionTitle(option, targetLocale)}
                                    {renderLock()}
                                </div>
                            )}
                            {!isDisabled && (
                                <Input
                                    key={`${option.id}_${targetLocale}`}
                                    defaultValue={utils.getOptionTitle(option, targetLocale)}
                                    onBlur={({ value }) => utils.updateOptiontitle(option, value, targetLocale)}
                                />
                            )}
                        </td>
                    </tr>
                ))}
            </>
        )
    }

    return (
        sections.map((section) => {
            switch (section.type) {
                case 'content': return renderContent(section)
                case 'subQuestion': return renderSubQuestions(section)
                default: return renderOptions(section)
            }
        })
    )
}

export default QuestionSection
